import React from 'react';
import './index.css'
import ReactResizeDetector from 'react-resize-detector';
import BigNumber from "bignumber.js"
import {toSignificant} from './utils'
Date.prototype.addDays = function (days) {
    this.setTime(this.getTime() + (days * 24 * 60 * 60 * 1000));
    return this;
}
Date.prototype.addHours = function (days) {
    var date = new Date(this.valueOf());
    date.setHours(date.getHours() + days);
    return date;
}
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

CanvasRenderingContext2D.prototype.roundRect = function (x, y, width, height, radius, fill, stroke) {
    var cornerRadius = { upperLeft: radius, upperRight: radius, lowerLeft: radius, lowerRight: radius };
    if (typeof stroke == "undefined") {
        stroke = true;
    }
    if (typeof radius === "object") {
        for (var side in radius) {
            cornerRadius[side] = radius[side];
        }
    }

    this.beginPath();

    this.moveTo(x + cornerRadius.upperLeft, y);
    this.lineTo(x + width - cornerRadius.upperRight, y);
    this.quadraticCurveTo(x + width, y, x + width, y + cornerRadius.upperRight);
    this.lineTo(x + width, y + height - cornerRadius.lowerRight);
    this.quadraticCurveTo(x + width, y + height, x + width - cornerRadius.lowerRight, y + height);
    this.lineTo(x + cornerRadius.lowerLeft, y + height);
    this.quadraticCurveTo(x, y + height, x, y + height - cornerRadius.lowerLeft);
    this.lineTo(x, y + cornerRadius.upperLeft);
    this.quadraticCurveTo(x, y, x + cornerRadius.upperLeft, y);
    this.closePath();
    if (stroke) {
        this.stroke();
    }
    if (fill) {
        this.fill();
    }
    this.shadowColor = "black";
    this.shadowBlur = 0;
    this.shadowOffsetX = 0;
    this.shadowOffsetY = 0;
}
function getAmounts(date,hours = false){
  var hours_t = parseInt((date.getHours()/8)+'')
  return date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate()+(hours ? " "+hours_t : "");
}
var monthNames = [
];
for (let mon of months)
    monthNames.push(mon.substring(0,3))
class InfinityGraph extends React.Component {
    constructor(props) {
        super(props)
        this.time = props.time == undefined ? "7d" : props.time;
        this.wallet = props.wallet;
        this.updateCanvas = this.updateCanvas.bind(this);
        this.calculateValues = this.calculateValues.bind(this);
        this.changeTimeFrame = this.changeTimeFrame.bind(this);
        this.hovering = this.hovering.bind(this);
        this.canvas = React.createRef();
        this.container = React.createRef();
        this.key = props.key
        this.clearCanvas = this.clearCanvas.bind(this)
        this.canvasTop = React.createRef();
        this.formatNumbers=this.formatNumbers.bind(this)
        this.firstLoad = true;
        this.resizeState = this.resizeState.bind(this)
        this.points = {}
        this.checkCoinUpdated=this.checkCoinUpdated.bind(this)
        var size_aux_last = 0;
        var auxDate = new Date()
        this.fontFamily=props.fontFamily
        var name = monthNames[auxDate.getMonth()] + " " + auxDate.getDate();
        this.title = props.title
        this.subtitle = props.subtitle
        days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        this.opacity = props.opacity == undefined ? 1 : props.opacity
        this.state = {
          width:props.width,
          height:props.height,
          emergency:false,
          amounts:props.amounts == undefined ? [] : props.amounts.sort((a,b)=>a.timestamp > b.timestamp ? 1 : -1),
          title:props.title,
          baseChange:props.baseChange != undefined ? props.baseChange : 0,
          currency: props.currency == undefined ? {
              symbol:"$",
              rate:1,
              decimals:2
          } : props.currency,
          base:props.base,
          showHover:props.showHover == undefined ? true : props.showHover,
          showDetailsGraph:props.showDetailsGraph == undefined ? true : props.showDetailsGraph,
          showVertical:props.showVertical == undefined ? true : props.showVertical,
          showLines:props.showLines == undefined ? true : props.showLines,
          showTime:props.showTime == undefined ? true : props.showTime,
          showAmounts:props.showAmounts == undefined ? true : props.showAmounts,
          selected:'month',
          reverseX:props.reverseX == undefined ? false : props.reverseX,
          reverseY:props.reverseY == undefined ? false : props.reverseY,
        }
        this.color = {
          gradient_a:"#FF00FF",
          gradient_b:"#FF0000",
          gradient_c:"#FFAABB",
          gradient_d:"#11BBCC",
          font_second:"#000000",
          clearest:"#FFFFFF",
          clear:"#11CC33",
          line_second:"#1122BB",
          background_thr:"#BB1100",
          clear:"#0000FF",
          background:"#550055"
        }
        if(props.color != undefined)
          this.color = Object.assign({}, this.color,props.color)
        this.changeDay = this.changeDay.bind(this);
        this.changeWeek = this.changeWeek.bind(this);
        this.changeMonth = this.changeMonth.bind(this);
        this.change3Month = this.change3Month.bind(this);

        this.changeCurrency = this.changeCurrency.bind(this);
        this.changeBase = this.changeBase.bind(this);
        this.changeBaseChange = this.changeBaseChange.bind(this);
        this.changeAmounts = this.changeAmounts.bind(this);

    }
    changeCurrency(currency){
      this.setState({currency})
    }
    changeBase(base){
      this.setState({base})
    }
    changeAmounts(amounts){
      var ts =this;
      if(amounts == undefined)
        return;
      this.setState({amounts:amounts.sort((a,b)=>a.timestamp > b.timestamp ? 1 : -1)},function(){
        ts.clearCanvas();
        if(ts.canvas.current != undefined){
          const cxt = ts.canvas.current.getContext('2d');
          cxt.clearRect(0, 0, ts.state.width, ts.state.height);
        }
        ts.calculateValues()
      })
    }
    changeBaseChange(baseChange){
      this.setState({baseChange})
    }
    clearCanvas() {
        const ctx = this.canvasTop.current.getContext('2d');
        ctx.clearRect(0, 0, this.state.width, this.state.height);
    }
    resizeState(width,height) {
      var ts =this;
      this.setState({
          width: width,
          height:height
      },function(){
        ts.updateCanvas();
      })

    }
    componentDidMount(){
      this.calculateValues();
    }
    changeDay() {
        this.changeTimeFrame('month');
        this.setState({ selected: 'month' });
    }
    changeWeek() {
        this.changeTimeFrame('3month');

        this.setState({ selected: '3month' });

    }
    changeMonth() {
        this.changeTimeFrame('year');
        this.setState({ selected: 'year' });

    }
    change3Month() {
        this.changeTimeFrame('all');
        this.setState({ selected: 'all' });

    }

    hovering(e) {
        if(!this.state.showHover)
          return;
        var font_second = this.color.font_second;
        var clear = this.color.clearest;
        var blue_clear =  this.color.clear
        var line_second = this.color.line_second
        var d = {}
        var points = this.points;
        var keys = Object.keys(points)
        if(parseInt(e.nativeEvent.offsetX) == parseInt(this.lastX) || !e.nativeEvent.offsetX || isNaN(e.nativeEvent.offsetX))
          return;
        this.lastX = parseInt(e.nativeEvent.offsetX);
        if (keys.length > 0) {
            var x = parseInt(e.nativeEvent.offsetX)
            var minDistance = 9999;
            var selected = -1;
            for (var i = 0; i < keys.length; i++) {
                var dist = Math.abs(keys[i] - x);
                if (dist < minDistance) {
                    minDistance = dist;
                    selected = keys[i];
                }

            }
            if (this.canvasTop.current == undefined)
                return;
            const ctx = this.canvasTop.current.getContext('2d');
            ctx.scale(1, 1);
            if(this.state.reverseX)
            ctx.scale(-1, 1);
            if(this.state.reverseY)
            ctx.scale(1,-1)
              ctx.clearRect(0, 0, this.state.width, this.state.height);
              if(this.state.showVertical){
                ctx.beginPath();
                ctx.strokeStyle = font_second+"AA";
                ctx.setLineDash([10, 10]);
                ctx.moveTo(selected, 47)
                ctx.lineTo(selected, this.state.height - 53)
                ctx.stroke();
                ctx.closePath();
                ctx.setLineDash([]);
              }
              var grd = ctx.createLinearGradient(this.state.width / 2, 47, this.state.width / 2, this.state.height+69);
              grd.addColorStop(0, this.color.gradient_a);
              grd.addColorStop(0.33, this.color.gradient_b);
              grd.addColorStop(0.66, this.color.gradient_c);
              grd.addColorStop(1, this.color.gradient_d);
              ctx.beginPath();
              ctx.strokeStyle = grd;
              ctx.lineWidth = 3;
              ctx.arc(selected, points[selected][0], 10, 0, 2 * Math.PI);
              ctx.stroke();
              ctx.closePath();
              ctx.lineWidth =1;
              ctx.beginPath();
              ctx.strokeStyle = this.color.clearest;
              ctx.fillStyle = this.color.clearest;
              ctx.arc(selected, points[selected][0], 4, 0, 2 * Math.PI);
              ctx.fill();
              ctx.stroke();
              ctx.closePath();
              ctx.beginPath();
              ctx.strokeStyle = this.color.clearest;
              ctx.fillStyle = this.color.clearest;
              ctx.arc(selected, points[selected][0], 4, 0, 2 * Math.PI);
              ctx.fill();
              ctx.stroke();
              ctx.closePath();
              if(this.state.showDetailsGraph){
                ctx.fillStyle = this.color.background_thr;
                ctx.strokeStyle = this.color.background_thr;
                ctx.font = "13px "+this.fontFamily;
                var date_point = points[selected][2];
                var auxDate = ","
                var text_top = days[date_point.getDay()] + ", " + months[date_point.getMonth()] + " " + date_point.getDate() + auxDate + " " + date_point.getFullYear()
                var measure_text = ctx.measureText(text_top)
                var text = this.formatNumbers(points[selected][1]*this.state.currency.rate);
                ctx.font = "15.5px "+this.fontFamily;
                var measure_text_2 = ctx.measureText(text)
                ctx.font = "13px "+this.fontFamily;
                var sizeBOX = measure_text.width + 30;
                if(measure_text.width < measure_text_2.width)
                  sizeBOX = measure_text_2.width + 30;
                var ct = 100;
                if (this.state.height / 2 > parseInt(points[selected][0]))
                    ct = -20
                var sizeBOXBOX = sizeBOX;
                if (this.state.width / 2 > parseInt(selected))
                    sizeBOXBOX = 0
                ctx.roundRect(parseInt(selected) - 1 - sizeBOXBOX, parseInt(points[selected][0]) - ct, sizeBOX, 80, 8, true, true);
                ctx.beginPath();
                ctx.fillStyle = font_second
                ctx.strokeStyle =font_second

                var size_w = sizeBOX * 0.5;
                size_w -= measure_text_2.width * 0.5;
                var size_w_pt = sizeBOX * 0.5;
                size_w_pt -= measure_text.width * 0.5;

                ctx.fillText(text_top, parseInt(selected) + size_w_pt - sizeBOXBOX, parseInt(points[selected][0]) - ct + 30)
                ctx.closePath();
                ctx.beginPath();
                ctx.font = "15.5px "+this.fontFamily;
                ctx.fillStyle = this.color.clearest;
                ctx.strokeStyle = this.color.clearest;
                ctx.fillText(this.formatNumbers(points[selected][1]*this.state.currency.rate), parseInt(selected) + size_w - sizeBOXBOX, parseInt(points[selected][0]) - ct + 58)
                ctx.closePath();

            }

        }
    }

    changeTimeFrame(time) {
        this.time = time;
        this.calculateValues();

    }
    checkCoinUpdated(args){
      var wallet = args[0]
      if(wallet == this.wallet.selected) {
        this.calculateValues();
      }
    }


    formatNumbers(new_balance){
      var decimals = 2;
      if (new_balance < 0.1) {
        decimals = 4;
      }
      if (new_balance < 0.001) {
        decimals = 6;
      }
      if (new_balance < 0.00001) {
        decimals=2;
        new_balance = new BigNumber(0);
      }
      if(new_balance == 0){
        decimals = 2
      }

      var nm = new BigNumber(new_balance)
      return  this.state.currency.symbol + nm.toFormat(decimals);
    }


    async calculateValues() {

        function round10(x) {
            return Math.ceil(x / 10.0) * 10.0;
        }
        if(this.state.amounts == undefined || this.state.amounts.length ==0)
          return;
        this.firstLoad = false;
        var end = new Date();
        end.setHours(0,0,0,0)
        var start = new Date();
        start.setHours(0, 0, 0, 0)

        var timeframe = 7;
        if (this.time == 'month') {
            timeframe = 30;
        }
        else if (this.time == '3month') {
            timeframe = 90;
        }
        else if (this.time == 'year') {
            timeframe = 365;
        }
        else if (this.time == 'all') {
            var dateA = new Date(2013, 3, 27);
            var dateB = new Date();
            var timeDiff = dateB.getTime() - dateA.getTime();
            timeframe = parseInt(timeDiff / (1000 * 3600 * 24));
            timeframe+=1;
        }

        start = new Date(this.state.amounts[0].timestamp*1000)

        var dt_now = new Date(this.state.amounts[this.state.amounts.length-1].timestamp*1000)


        this.balances = {};
        this.max_balance = 0;
        this.min_balance = 999999999999;
        var lastPrice = {}

        var now_str = getAmounts(dt_now,this.time == "7d");
        var bal = 0;
        while (true) {
          var start_srt = getAmounts(start,this.time == "7d");

              var data = this.state.amounts
              for(let am of data) {
                var dttt = new Date(am.timestamp*1000)
                if(getAmounts(dttt,this.time == "7d") == getAmounts(start,this.time == "7d")){
                  bal = am.amount
                }
              }

          if (bal > this.max_balance)
              this.max_balance = bal;
          if (bal < this.min_balance)
              this.min_balance = bal;

          this.balances[start.getTime()] = bal;
          if(this.time != "7d"){
            start.setHours(0,0,0,0);
            start = start.addHours(27)
            start.setHours(0,0,0,0);
          }
          else{
            start = start.addHours(4)
          }

          if (start.getTime() > dt_now.getTime())
            break;

        }
        this.max_balance = this.max_balance
        this.updateCanvas();
    }

    async updateCanvas() {
        if (this.balances == undefined)
            return;

        var height = this.state.height

        this.points = {}
        if (this.canvas.current == undefined)
            return;
        const ctx = this.canvas.current.getContext('2d');
        var width = this.state.width-10;
        ctx.beginPath();
        ctx.fillStyle = this.color.background;
        ctx.fillRect(0, 0, width+15, height)
        ctx.closePath();
        ctx.beginPath();
        var font_second = this.color.font_second;
        var clear = this.color.clearest;
        var blue_clear = this.color.clear
        var line_second = this.color.line_second

        ctx.fillStyle = line_second
        ctx.strokeStyle = line_second
        ctx.font = "13px "+this.fontFamily;
        ctx.lineWidth = 1;
        var max_balance = this.max_balance - this.min_balance;
        var frag_balance = max_balance / 8.0;
        var init_x = 0;
        var auxposx = 0;
        var all_empty = true;
        if(this.state.showAmounts)
        for (var i = 0; i <= 8; i++) {
            if (max_balance != 0) {
                all_empty = false;
                var text_show = frag_balance * (8 - i)* this.state.currency.rate
                if(i == 8)
                  text_show = "0.00"
                var measure_text_2 = ctx.measureText(toSignificant(text_show,this.state.currency.decimals)).width

                if (measure_text_2 + 10 > auxposx){
                    auxposx = measure_text_2+ 10
                  }
                else{
                }
            }
        }
        if(this.state.showAmounts)
        for (var i = 0; i <= 8; i++) {
            if (max_balance != 0) {
                all_empty = false;
                var text_show = frag_balance * (8 - i)* this.state.currency.rate
                if(i == 8)
                  text_show = "0.00"
                var measure_text_2 = ctx.measureText(toSignificant(text_show,this.state.currency.decimals)).width
                if (measure_text_2 + 10 > auxposx){
                    auxposx = measure_text_2+ 10
                    ctx.fillText(  toSignificant(text_show,this.state.currency.decimals) , init_x, i / 8 * (height - 100) + 50)
                  }
                else{
                  ctx.fillText(  toSignificant(text_show,this.state.currency.decimals) , init_x + (auxposx - 10) - measure_text_2, i / 8 * (height - 100) + 50)
                }
            }

        }
        if(all_empty){
          init_x = 15;
          auxposx = 15;
          width += 15;

        }
        auxposx = 0;
        ctx.closePath();
        var balances = this.balances;
        ctx.beginPath();
        var keys = Object.keys(balances);
        ctx.fillStyle = line_second
        ctx.strokeStyle = line_second
        var numPoints = parseInt(keys.length / 9.0);
        if(window.innerWidth < 1750)
          numPoints = parseInt(keys.length / 8.0);
        if(window.innerWidth < 1600)
          numPoints = parseInt(keys.length / 7.0);
        if(window.innerWidth < 1500)
          numPoints = parseInt(keys.length / 6.0);
        var size_aux_last = 0;
        var auxDate = new Date(parseInt(keys[keys.length-1]))
        var name = monthNames[auxDate.getMonth()] + " " + auxDate.getDate();
        size_aux_last = (ctx.measureText(name).width) * 0.5;

        var frag_date = (parseFloat(width)) / parseFloat(keys.length);
        if (numPoints < 1)
            numPoints = 1;
        if(this.state.showTime)
        for (var i = 0; i < keys.length; i += numPoints) {
            var posx = auxposx + (i * frag_date)
            var auxDate = new Date(parseInt(keys[i]))
            var name = monthNames[auxDate.getMonth()] + " " + auxDate.getDate();
            var measure_text_2 = ctx.measureText(name)
            var size_aux_tt = (measure_text_2.width) * 0.5;
            if(all_empty && i == 0){
              size_aux_tt = 0;
            }
            else if(all_empty && i + numPoints >= keys.length){
              size_aux_tt = (measure_text_2.width)
            }
            ctx.fillText(name, posx-size_aux_tt, height - (height*0.05));
            ctx.stroke();
        }
        ctx.closePath();
        if(this.state.showLines)
        for (var i = 0; i <= 8; i++) {
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.strokeStyle = line_second + "55";
            ctx.moveTo(auxposx, Math.ceil(i / 8 * (height - (height*0.1)) + (height*0.1)));
            ctx.lineTo((width - (height*0.05)), Math.ceil(i / 8 * (height - (height*0.1)) + (height*0.1)));
            ctx.stroke();
            ctx.closePath();
        }
        frag_date = (parseFloat(width)) / parseFloat(keys.length-1);
        if(this.min_balance != this.max_balance){
              ctx.beginPath();
              var grd = ctx.createLinearGradient(width / 2, (height*0.05), width / 2, height - (height*0.05));
              if(this.min_balance != this.max_balance){
                  grd.addColorStop(0, this.color.gradient_a);
                  grd.addColorStop(0.33, this.color.gradient_b);
                  grd.addColorStop(0.66, this.color.gradient_c);
                  grd.addColorStop(1, this.color.gradient_d);
                  ctx.fillStyle = grd;
                  ctx.strokeStyle = grd;
                  ctx.filter = 'blur(0.3px)';
                  ctx.lineWidth = 1.5;

              }
              else{
                ctx.fillStyle = this.color.gradient_d;
                ctx.strokeStyle = this.color.gradient_d;
                ctx.lineWidth = 1;

              }
              var aposy = (height*0.1) + (height - (height*0.1)) * (1 - ((balances[keys[0]] -this.min_balance) / max_balance))
              if (balances[keys[0]] == 0)
                  aposy = (height*0.1) + (height - (height*0.1));
              ctx.moveTo(0, aposy);
              function gradient(a, b) {
                return (b.y-a.y)/(b.x-a.x);
              }
              var m = 0;
              var dx1 = 0;
              var dx2 = 0;
              var prePoint={x:auxposx,y:aposy}
              for (var i = 1; i < keys.length; i++) {
                  var bposx = auxposx + ((i) * frag_date);
                  var bposy = (height*0.05) + (height - (height*0.1)) * (1 - ((balances[keys[i]] -this.min_balance) / max_balance))
                  if (balances[keys[i]] == 0)
                      bposy = (height*0.05) + (height - (height*0.1));
                  var curP = {
                    x:bposx,
                    y:bposy
                  }
                  ctx.lineTo(curP.x, curP.y);
              }
              ctx.stroke();
              ctx.closePath();
              ctx.beginPath();
              grd = ctx.createLinearGradient(width / 2.0, (height*0.1), width / 2.0, height - (height*0.1));
              grd.addColorStop(0, this.color.gradient_a+(parseInt(255*this.opacity).toString(16).length == 2 ? parseInt(255*this.opacity).toString(16) : "0"+parseInt(255*this.opacity).toString(16)));
              grd.addColorStop(0.33, this.color.gradient_b+(parseInt(255*this.opacity*0.66).toString(16).length == 2 ? parseInt(255*this.opacity*0.66).toString(16) : "0"+parseInt(255*this.opacity*0.66).toString(16)));
              grd.addColorStop(0.66, this.color.gradient_c+(parseInt(255*this.opacity*0.33).toString(16).length == 2 ? parseInt(255*this.opacity*0.33).toString(16) : "0"+parseInt(255*this.opacity*0.33).toString(16)));
              grd.addColorStop(1, this.color.gradient_d+"00");

              ctx.fillStyle = grd;
              ctx.strokeStyle = grd;
              ctx.filter = 'none';
              ctx.lineWidth = 1.5;
              var aposy = (height*0.1) + (height - (height*0.1)) *(1 - ((balances[keys[0]] -this.min_balance) / max_balance))
              if (balances[keys[0]] == 0)
                  aposy = (height*0.1) + (height - (height*0.1));
              ctx.moveTo(auxposx, aposy);
              var m = 0;
              var dx1 = 0;
              var dx2 = 0;
              var prePoint={x:auxposx,y:aposy}

              for (var i = 1; i < keys.length; i++) {
                  var bposx = auxposx + ((i) * frag_date);
                  var bposy = (height*0.05) + (height - (height*0.1)) * (1 - ((balances[keys[i]] -this.min_balance) / max_balance))

                  var nextPoint = keys[i+1]
                  var curP = {
                    x:bposx,
                    y:bposy
                  }

                  ctx.lineTo(curP.x, curP.y);

              }

              ctx.lineTo(width+50, prePoint.y);
              ctx.lineTo(width+50, height + (height*0.1));
              ctx.lineTo(-50, height + (height*0.1));
              ctx.lineTo(-50,aposy);
              ctx.lineTo(auxposx,aposy);
              ctx.fill();
              ctx.closePath();
        }
        else{
          ctx.beginPath();
          grd = ctx.createLinearGradient(width / 2.0, (height*0.1), width / 2.0, height - (height*0.1));
          grd.addColorStop(0, this.color.gradient_a);
          grd.addColorStop(0.33, this.color.gradient_b);
          grd.addColorStop(0.66, this.color.gradient_c);
          grd.addColorStop(1, this.color.gradient_d);

          ctx.fillStyle = grd;
          ctx.strokeStyle = grd;
          ctx.filter = 'none';
          ctx.lineWidth = 1.5;
          ctx.moveTo(0, (height*0.25));
          ctx.lineTo(width, (height*0.25));
          ctx.stroke();
          ctx.closePath();

        }

        this.setState({height:height, emergency:all_empty})

    }



    render() {
      var textDay = '1m'
      if (this.state.selected == 'month')
          textDay = '1 month'
      var textWeek = '3m';
      if (this.state.selected == '3month')
          textWeek = '3 months'
      var textMonth = '1y'
      if (this.state.selected == 'year')
          textMonth = '1 year'
      var text3Month = 'all'

      var daySelected = "";
      var weekSelected = "";
      var monthSelected = "";
      var threemonthSelected = "";

      if (this.state.selected == 'month')
          daySelected = "selectedDashboardGraph";
      if (this.state.selected == '3month')
          weekSelected = "selectedDashboardGraph";
      if (this.state.selected == 'year')
          monthSelected = "selectedDashboardGraph";
      if (this.state.selected == 'all')
          threemonthSelected = "selectedDashboardGraph";


        var top = "0"
        if (this.max_balance == this.min_balance && this.min_balance) {
            top = "50%"
        }
        return (
          <div className="dashboardGraphMain" key={this.key} style={{ height:this.state.showDetailsGraph ? this.state.height+100 : this.state.height,background:this.color.background,width:this.state.width }} ref={this.container}>
                <div className="dashboardGraphTop" style={{display:this.state.showDetailsGraph ? null : "none"}}>
                    <div className="containerTopGraph">
                      <div className="titleName">{this.state.title}</div>
                      <div className="valueName">{this.state.currency.symbol}{toSignificant(this.state.base,this.state.currency.decimals)}</div>
                      <div className="baseChangeName" style={{color:this.state.baseChange < 0 ? "red" : this.state.baseChange > 0 ? "green" : this.color.font_second}}>{this.state.baseChange}%</div>
                    </div>
                    <div className="dateButtons">
                        <div className="dashboardGraphButton" onClick={this.changeDay} id={daySelected+this.key}><div>{textDay}</div></div>
                        <div className="dashboardGraphButton" onClick={this.changeWeek} id={weekSelected+this.key}><div>{textWeek}</div></div>
                        <div className="dashboardGraphButton" onClick={this.changeMonth} id={monthSelected+this.key}><div>{textMonth}</div></div>
                        <div className="dashboardGraphButton" onClick={this.change3Month} id={threemonthSelected+this.key}><div>{text3Month}</div></div>
                    </div>
                </div>
                <div className="dashboardGraphGraph" style={{ height:this.state.height }}>
                  <div style={{ width: "100%", height: "100%", position: "relative", width:this.state.width, marginLeft:this.state.showTime ? -15 : 0 }} ref={this.container} onMouseLeave={this.clearCanvas} onMouseMove={this.hovering}>
                      <canvas style={{ position: "absolute", top: top, left: "0px", letterSpacing:"0.72px"}}
                          width={this.state.width} height={this.state.height} ref={this.canvas} />
                      <canvas style={{ position: "absolute", top: top, left: "0px", letterSpacing:"0.72px" }} width={this.state.width} height={this.state.height}  ref={this.canvasTop} />
                  </div>
                </div>
          </div>
        );
    }
}
export default InfinityGraph;
